import React from 'react';

export function PageBody({ children, className = '' }) {
  const classes = ['mp-page-body', className].filter(Boolean).join(' ');
  return <div className={classes}>{children}</div>;
}

export function PrimaryColumn({ children, className = '' }) {
  const classes = ['mp-page-primary', className].filter(Boolean).join(' ');
  return <section className={classes}>{children}</section>;
}

export function SecondaryColumn({ children }) {
  return <aside className="mp-page-secondary">{children}</aside>;
}
